import { navLinks } from "@/constants/navbar";
import { useTranslation } from "react-i18next";
import { Link, useParams, useLocation } from "react-router-dom";

export default function NavbarLinks({ scrolled }: { scrolled: boolean }) {
    const { t } = useTranslation();
    const { lang } = useParams();
    const location = useLocation();
    const baseRoute = `/${lang || "id"}`;
    const isFarmDetail = location.pathname.match(
        new RegExp(`^${baseRoute}/farm/[^/]+$`),
    );

    return (
        <div
            className={`${isFarmDetail ? "hidden md:flex" : "flex"} justify-center items-center transition-all duration-300 ease-in-out relative z-10 overflow-hidden ${
                scrolled
                    ? "h-0 opacity-0 pointer-events-none md:h-14 md:opacity-100 md:pointer-events-auto md:bg-white md:dark:bg-dark md:overflow-visible"
                    : "h-11 md:h-14 opacity-100 bg-white dark:bg-dark pointer-events-auto md:overflow-visible"
            }`}>
            <div className="flex gap-1.5 md:gap-2 lg:gap-4 overflow-x-auto scrollbar-hide px-2 md:px-4 w-full justify-center md:w-auto">
                {navLinks(t).map((link) => {
                    const path = `${baseRoute}${link.path}`;
                    let isActive = false;

                    if (path === baseRoute || path === `${baseRoute}/`) {
                        isActive =
                            location.pathname === path ||
                            location.pathname === `${path}/`;
                    } else {
                        isActive = location.pathname.startsWith(path);
                    }

                    const isMobileVisible = [
                        "/shop",
                        "/farm",
                        "/about",
                    ].includes(link.path);

                    return (
                        <Link
                            key={link.label}
                            to={path}
                            className={`px-3 md:px-4 py-1 md:py-1.5 rounded-full text-[13px] md:text-sm font-medium transition-all duration-300 whitespace-nowrap ${!isMobileVisible ? "hidden md:block" : "block"} ${isActive ? "bg-gold text-white dark:bg-gold-light dark:text-dark hover:white" : "text-dark dark:text-white hover:text-gold dark:hover:text-gold hover:bg-gray-50 dark:hover:bg-dark"} ${scrolled ? "scale-0 md:scale-100" : "scale-100"}`}>
                            {link.label}
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
